import { createContext } from 'react'

export const AuthTokenContext = createContext('')
